import Brokerages from "@/views/console/Brokerages";
import C from "@/utils/constants";

export default [
  {
    path: "brokerages",
    component: Brokerages,
    meta: {
      roles: [
        C.ROLE.ADMIN,
        C.ROLE.MANAGER,
        C.ROLE.QA_TEAM,
        C.ROLE.CSR_SUPERVISOR,
        C.ROLE.AGENT_ENGAGEMENT,
      ],
    },
    children: [
      {
        path: "",
        name: "brokerages",
        component: () =>
          import("../components/console/brokerages/BrokeragesList"),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
      },
      { path: "view", redirect: "/console/agents" },
      {
        path: "view/:id",
        name: "view-brokerage",
        components: {
          default: () =>
            import("../components/console/brokerages/BrokeragesList"),
          view: () =>
            import("../components/console/brokerage-details/BrokerageDetail"),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              brokerId: route.params.id,
              parent: "brokerages",
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
      },
      {
        path: "view/:id/agent/:agentId",
        name: "view-brokerage-agent",
        components: {
          default: () =>
            import("../components/console/brokerages/BrokeragesList"),
          view: () => import("../components/console/agent-details/AgentDetail"),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              brokerId: route.params.id,
              agentId: route.params.agentId,
              parent: "view-brokerage",
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
        children: [
          {
            path: "referral/:referralId",
            name: "view-brokerage-agent-referral-details",
            component: () =>
              import("../components/console/referral-details/ReferralDetails"),
            props: (route) => {
              return {
                mode: "view",
                agentId: route.params.id,
                parent: "view-brokerage-agent",
              };
            },
          },
        ],
      },
      {
        path: "email/:id",
        name: "brokerage-email-settings",
        component: () => import("@/components/console/settings/EmailTemplates"),
        meta: {
          roles: [C.ROLE.ADMIN, C.ROLE.MANAGER, C.ROLE.AGENT_ENGAGEMENT],
          title: "Brokerage Email Settings",
        },
      },
    ],
  },
];
